import { makeStyles } from "@material-ui/core/styles";

const useConnectionsStyles = makeStyles(theme => ({
	mainPaper: {
		flex: 1,
		padding: theme.spacing(3),
		overflowY: "scroll",
		...theme.scrollbarStyles,
		backgroundColor: theme.palette.background.default,
		position: 'relative',
		zIndex: 1,
	},
	connectionsGrid: {
		marginTop: theme.spacing(2),
	},
	connectionCard: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: '16px',
		boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
		overflow: 'hidden',
		position: 'relative',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		transition: 'transform 0.2s, box-shadow 0.2s',
		'&:hover': {
			transform: 'translateY(-4px)',
			boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
		},
	},
	cardHeader: {
		background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
		padding: theme.spacing(2.5),
		position: 'relative',
		flex: 1,
	},
	// El tamaño lo fija `ChannelIcon` vía `size` (estilo inline, que gana a esta clase).
	// Aquí solo queda la separación respecto al texto de la tarjeta.
	whatsappIcon: {
		marginRight: theme.spacing(1.5),
	},
	connectionInfo: {
		flex: 1,
		minWidth: 0,
	},
	connectionName: {
		fontSize: '18px',
		fontWeight: 'bold',
		color: '#333',
		marginBottom: theme.spacing(0.5),
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	phoneNumber: {
		fontSize: '14px',
		color: '#666',
		marginBottom: theme.spacing(0.5),
	},
	connectionDetail: {
		fontSize: '12px',
		color: '#888',
		marginBottom: theme.spacing(0.25),
		display: 'flex',
		alignItems: 'center',
	},
	detailLabel: {
		fontWeight: '600',
		marginRight: theme.spacing(0.5),
		minWidth: '80px',
	},
	detailValue: {
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	menuButton: {
		position: 'absolute',
		top: theme.spacing(2),
		right: theme.spacing(2),
		color: '#666',
	},
	statusBadge: {
		marginTop: theme.spacing(1),
		height: '24px',
		fontSize: '12px',
		fontWeight: 'bold',
		borderRadius: '12px',
		padding: '0 12px',
	},
	connectedBadge: {
		backgroundColor: '#ffffff',
		color: '#4caf50',
		border: '1px solid #4caf50',
	},
	disconnectedBadge: {
		backgroundColor: '#ffffff',
		color: '#f44336',
		border: '1px solid #f44336',
	},
	cardBody: {
		padding: theme.spacing(2),
		backgroundColor: '#f5f5f5',
		marginTop: 'auto',
	},
	actionButton: {
		width: '100%',
		justifyContent: 'space-between',
		padding: theme.spacing(1.5, 2),
		backgroundColor: '#ffffff',
		color: '#333',
		textTransform: 'none',
		fontSize: '14px',
		borderRadius: '8px',
		boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
		'&:hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	defaultBadge: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(5),
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#ff9800',
		color: '#ffffff',
		padding: '4px 8px',
		borderRadius: '12px',
		fontSize: '10px',
		fontWeight: 'bold',
		boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
		zIndex: 10,
	},
	defaultIcon: {
		fontSize: '14px',
		marginRight: '4px',
	},
	addConnectionCard: {
		backgroundColor: theme.palette.background.paper,
		borderRadius: '16px',
		border: `2px dashed ${theme.palette.primary.main}`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '280px',
		cursor: 'pointer',
		transition: 'all 0.2s',
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
			borderColor: theme.palette.primary.dark,
			transform: 'translateY(-4px)',
			boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
		},
	},
	addConnectionText: {
		color: theme.palette.text.primary,
		fontSize: '18px',
		fontWeight: '500',
		textAlign: 'center',
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
	},
}));

export default useConnectionsStyles;
